import Training from './container.js'
export default Training
